module.exports = __webpack_public_path__ + "img/img_school.a28ee958.png";